import { render, staticRenderFns } from "./VisitorStatistics.vue?vue&type=template&id=0890939e&scoped=true&"
import script from "./VisitorStatistics.vue?vue&type=script&lang=js&"
export * from "./VisitorStatistics.vue?vue&type=script&lang=js&"
import style0 from "./VisitorStatistics.vue?vue&type=style&index=0&id=0890939e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0890939e",
  null
  
)

export default component.exports